import { ArrowLeft, ArrowRight, IcoFilterSquare } from '@icons';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FilterFieldType, MIN_OPTIONS_COUNT_FOR_ADVANCED_FILTER } from './CustomFilter';
import SearchCheckboxAdvancedFilter from './SearchCheckboxAdvancedFilter';
import ResetFilter from './ResetFilter';
import ControlOption from './ControlOption';
import BooleanAdvancedOption from './BooleanAdvancedOption';
import StaticAdvancedOption from './StaticAdvancedOption';
import BooleanExtraAdvanceOption from './BooleanExtraAdvanceOption';

interface AdvancedFilterProps {
	pageName: string;
	projectName: string;
	filterFields: FilterFieldType[];
	activeFilters: { [key: string]: string[] };
	setActiveFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
	handleFilterSet: (field: FilterFieldType, option: { value: string }, isActive: boolean) => void;
	handleFilterReset: () => void;
	initialFilters: { [key: string]: string[] };
	setInitialFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const AdvancedFilter: React.FC<AdvancedFilterProps> = ({
	pageName,
	projectName,
	filterFields,
	activeFilters,
	setActiveFilters,
	handleFilterSet,
	handleFilterReset,
	initialFilters,
	setInitialFilters,
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const renderAdvOption = (field: FilterFieldType, advOption: FilterFieldType['advancedOptions'][number]) => {
		switch (advOption.type) {
			case 'static':
				return <StaticAdvancedOption field={field} advOption={advOption} activeFilters={activeFilters} handleFilterSet={handleFilterSet} />;
			case 'boolean':
				return (
					<BooleanAdvancedOption field={field} advOption={advOption} activeFilters={activeFilters} setActiveFilters={setActiveFilters} />
				);
			case 'boolean-extra':
				return (
					<BooleanExtraAdvanceOption
						field={field}
						advOption={advOption}
						activeFilters={activeFilters}
						setActiveFilters={setActiveFilters}
					/>
				);
			case 'control':
				return <ControlOption field={field} activeFilters={activeFilters} handleFilterSet={handleFilterSet} />;
			default:
				return null;
		}
	};

	return (
		<>
			<Button
				onClick={() => {
					setIsModalOpen(true);
				}}
				className="btn custom-ghost-button"
				style={{
					textTransform: 'none',
					// color: '#06797F',
					display: 'flex',
					alignItems: 'center',
					gap: '0.5rem',
				}}
			>
				filtri avanzati
				<ArrowRight />
			</Button>
			<Modal
				fullscreen
				show={isModalOpen}
				onHide={() => {
					setIsModalOpen(false);
				}}
				contentClassName="custom-modal-content"
			>
				<Modal.Header
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Modal.Title>
						<h2 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Pagina: {pageName}</h2>
						<h3 style={{ fontSize: '18px' }}>PROGETTO: {projectName}</h3>
					</Modal.Title>
					<Button
						onClick={() => {
							setIsModalOpen(false);
						}}
						className="btn custom-ghost-button"
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '0.5rem',
							// color: '#06797F',
						}}
					>
						<ArrowLeft />
						indietro
					</Button>
				</Modal.Header>
				<Modal.Body
					style={{
						overflow: 'hidden',
					}}
				>
					{/* Contenuto del filtro avanzato */}

					<div
						style={{
							backgroundColor: '#DEE4F1',
							padding: '1.5rem',
							borderRadius: '8px 8px 0 0',
							height: '10%',
						}}
					>
						<h4
							style={{
								fontSize: '28px',
								fontWeight: '700',
								display: 'flex',
								alignItems: 'center',
								gap: '0.5rem',
							}}
						>
							<IcoFilterSquare />
							Filtri avanzati
						</h4>
					</div>
					<div
						style={{
							backgroundColor: '#fff',
							padding: '1.5rem',
							borderRadius: '0 0 8px 8px',
							display: 'grid',
							gap: '2.5rem',
							overflowY: 'auto',
							height: '90%',
						}}
					>
						{filterFields.map((field) => (
							<div
								key={field.name}
								style={{
									display: 'grid',
									gap: '1rem',
								}}
							>
								<h5
									style={{
										fontSize: '24px',
										fontWeight: '700',
									}}
								>
									{field.label}
								</h5>
								{field.optionsType === 'dynamic' ? (
									<div
										style={{
											display: 'flex',
											flexWrap: 'wrap',
											gap: '0.5rem',
										}}
									>
										{field.options.map((option, index) => {
											const isActive = activeFilters[field.queryParamName]?.includes(option.value);
											if (index >= MIN_OPTIONS_COUNT_FOR_ADVANCED_FILTER && field.searchCheckboxAdvancedFilter) return null;
											return (
												<Button
													onClick={() => {
														handleFilterSet(field, option, isActive);
													}}
													key={option.value}
													className={`btn ${isActive ? 'custom-primary-button' : 'custom-outline-button'}`}
													style={{
														borderRadius: '20px',
														textTransform: 'none',
														fontWeight: 400,
													}}
												>
													{option.label}
												</Button>
											);
										})}
										{field.searchCheckboxAdvancedFilter && field.options.length > MIN_OPTIONS_COUNT_FOR_ADVANCED_FILTER ? (
											<SearchCheckboxAdvancedFilter field={field} activeFilters={activeFilters} handleFilterSet={handleFilterSet} />
										) : null}
									</div>
								) : null}

								{field.advancedOptions ? (
									<div
										style={{
											borderLeft: '4px solid #DEE4F1',
											paddingLeft: '1rem',
											display: 'grid',
											gap: '2rem',
										}}
									>
										{field.advancedOptions.map((advOption) => {
											let key = `${advOption.name}_${advOption.options?.[0].value}`;
											if (advOption.extraQueryParams) {
												key += `_${advOption.extraQueryParams.map((extraQueryParam) => extraQueryParam.value).join('_')}`;
											}
											return (
												<div
													key={key}
													style={{
														display: 'grid',
														gap: '1rem',
													}}
												>
													<h5
														style={{
															fontSize: '24px',
															fontWeight: '700',
														}}
													>
														{advOption.label}
													</h5>

													{renderAdvOption(field, advOption)}
												</div>
											);
										})}
									</div>
								) : null}
							</div>
						))}
					</div>
				</Modal.Body>
				<Modal.Footer
					style={{
						gap: '1rem',
						marginTop: '1rem',
					}}
				>
					<ResetFilter handleFilterReset={handleFilterReset} activeFilters={activeFilters} />

					<Button
						className="btn custom-outline-button"
						style={{
							minWidth: '285px',
							padding: '12px 24px',
						}}
						onClick={() => {
							setIsModalOpen(false);
							if (Object.values(initialFilters).length === 0) return;
							setTimeout(() => {
								setActiveFilters(initialFilters);
								setInitialFilters({});
							}, 300);
						}}
					>
						Annulla
					</Button>
					<Button
						className="btn custom-primary-button"
						style={{
							minWidth: '285px',
							padding: '12px 24px',
						}}
						onClick={() => {
							setIsModalOpen(false);
						}}
					>
						Conferma
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default AdvancedFilter;
